export default __webpack_public_path__ + "static/media/sampleDashboard.0d223c64.png";